import React from "react";
import { Link } from "react-router-dom";

const blogs = [
  {
    id: 1,
    slug: "corporate-cab-hire-in-pune",
    title: "Corporate Cab Hire in Pune",
    image: "/images/keyword/12.jpg",
    date: "10 July 2026",
    category: "Corporate Travel",
    description:
      "Looking for reliable corporate cab hire in Pune? We provide professional employee transportation, executive travel, airport transfers, and customized cab solutions for businesses with safe, comfortable, and on-time services.",
  },
  {
    id: 2,
    slug: "business-travel-cab-services-in-delhi",
    title: "Business Travel Cab Services in Delhi",
    image: "/images/keyword/58.jpg",
    date: "14 July 2026",
    category: "Business Travel",
    description:
      "Choose our business travel cab services in Delhi for executive transportation, airport transfers, client meetings, and daily corporate travel with experienced drivers, premium vehicles, and dependable service every day.",
  },
  {
    id: 3,
    slug: "corporate-cab-services-in-kharadi-pune",
    title: "Corporate Cab Services in Kharadi",
    image: "/images/keyword/17.jpg",
    date: "18 July 2026",
    category: "Corporate Travel",
    description:
      "Book trusted corporate cab services in Kharadi for employee pickup and drop, executive travel, airport transfers, office transportation, and business meetings with reliable drivers and well-maintained vehicles.",
  },
  {
    id: 4,
    slug: "monthly-cab-services-pune",
    title: "Monthly Corporate Cab Hire in Pune",
    image: "/images/keyword/100.jpg",
    date: "20 July 2026",
    category: "Corporate Rental",
    description:
      "Our monthly corporate cab hire in Pune offers flexible rental plans, dedicated drivers, employee transportation, executive travel, and affordable mobility solutions tailored to offices, IT companies, and businesses.",
  },
  {
    id: 5,
    slug: "corporate-cab-booking-services-in-mumbai",
    title: "Corporate Cab Services in Mumbai",
    image: "/images/keyword/71.jpg",
    date: "24 July 2026",
    category: "Corporate Travel",
    description:
      "Experience premium corporate cab services in Mumbai with executive transportation, employee commute, airport transfers, business travel, and customized rental solutions designed for companies of every size and industry.",
  },
  {
    id: 6,
    slug: "corporate-cab-bookings-in-hyderabad",
    title: "Corporate Cab Bookings in Hyderabad",
    image: "/images/keyword/74.jpg",
    date: "28 July 2026",
    category: "Corporate Travel",
    description:
      "Book corporate cab services in Hyderabad for office transportation, executive travel, airport transfers, employee pickup and drop, and business trips with professional chauffeurs, modern vehicles, and reliable support.",
  },
];

const BlogSection = () => {
  return (
    <>
      {/* Banner */}

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="page-header-box text-center">
            <h1>Blogs</h1>
          </div>
        </div>
      </div>

      {/* Blog Section */}

      <section className="py-5 bg-light">
        <div className="container">

          <div className="text-center mb-5">
            <h6 className="text-primary fw-bold text-uppercase">
              Latest Blogs
            </h6>

            <h2 className="fw-bold">
              Corporate Travel Insights & Mobility Updates
            </h2>

            <p className="text-muted col-lg-8 mx-auto">
              Stay updated with travel tips, employee transportation,
              airport transfers, business travel, and corporate mobility
              services across Pune, Mumbai and All India.
            </p>
          </div>

          <div className="row">

            {blogs.map((blog) => (
              <div className="col-lg-4 col-md-6 mb-4" key={blog.id}>
                <div className="card border-0 shadow h-100">

                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="card-img-top"
                    style={{
                      height: "230px",
                      objectFit: "cover",
                    }}
                  />

                  <div className="card-body d-flex flex-column">

                    <span className="badge bg-primary mb-2">
                      {blog.category}
                    </span>

                    {/* <small className="text-muted">
                      {blog.date}
                    </small> */}

                    <h5 className="fw-bold mt-2">
                      {blog.title}
                    </h5>

                    <p className="text-muted">
                      {blog.description}
                    </p>

                    <Link
                      to={`/${blog.slug}`}
                      className="btn btn-primary mt-auto"
                    >
                      Read More →
                    </Link>

                  </div>

                </div>
              </div>
            ))}

          </div>

        </div>
      </section>
    </>
  );
};

export default BlogSection;